import resources from "../imgs/resources.png";
import req from "./files/requirements.txt";
import collab from "./files/Collaboration_Policy.pdf";
import grading from "./files/CSCI1410_Grading_Policy.pdf";
import fastx from "./files/fastX_guide.pdf";
import numpyguide from "./files/python_numpy_guide.pdf";
import gradescope from "./files/Gradescope_instructions.pdf";
import diversity from "./files/CSCI1410_diversity.pdf";

function ResourcesPage() {
  return (
    <div className="resources-page">
      <div className="resources">
        <img className="resources-img" src={resources}></img>
      </div>
      <div className="resources-wrapper">
        <div className="resource-card">
          <h2 style={{color:"ghostwhite"}}>Policies</h2>
          <a href={grading} target="_blank">
            <div>Grading and Late Day Policies</div>
          </a>
          <a href={collab} target="_blank">
            <div>Collaboration Policy</div>
          </a>
          <a href={diversity} target="_blank">
            <div>Diversity and Inclusion Missive</div>
          </a>
          <a href="https://forms.gle/dxRWtrvybc3Uk18Z9" target="_blank">
            <div>Extension Request Form</div>
          </a>
        </div>
        <div className="resource-card">
          <h2>Guides</h2>
          <a
            href="https://docs.google.com/document/d/19cs8-NkoNwdE06bHdPFHzDH6A8F6Z2QlxNzyjL3rkK0/edit?usp=sharing"
            target="_blank"
          >
            <div>Installation & Setup</div>
          </a>

          <a href={gradescope} target="_blank">
            <div>Gradescope</div>
          </a>

          {/* <a href={req} download="requirements.txt">
            <div>requirements.txt</div>
          </a> */}
          <a href="https://cs.brown.edu/about/system/connecting/ssh/" target="_blank">
            <div>Setting Up SSH</div>
          </a>
          <a href={fastx} target="_blank">
            <div>FastX Guide</div>
          </a>
          <a href={numpyguide} target="_blank">
            <div>Python & Numpy Guide</div>
          </a>
        </div>
        <div className="resource-card">
          <h2>Important Links</h2>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSflmtuVs2xBynlEmgrBfkOvUFvVMKAdzG_VacgyhR0I42RRXw/viewform"
            target="_blank"
          >
            <div>Anonymous Course Feedback Form</div>
          </a>
          <a href="https://edstem.org/us/courses/44858/" target="_blank">
            <div>EdStem</div>
          </a>
          <a href="https://hours.cs.brown.edu/" target="_blank">
            <div>Hours</div>
          </a>
          <a href="mailto: cs1410headtas@lists.brown.edu" target="_blank">
            <div>cs1410headtas@lists.brown.edu</div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ResourcesPage;
